import { render, staticRenderFns } from "./SettingOrari.vue?vue&type=template&id=739ed1e0&scoped=true&"
import script from "./SettingOrari.vue?vue&type=script&lang=js&"
export * from "./SettingOrari.vue?vue&type=script&lang=js&"
import style0 from "./SettingOrari.vue?vue&type=style&index=0&id=739ed1e0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "739ed1e0",
  null
  
)

export default component.exports